import { render, staticRenderFns } from "./Deductions.vue?vue&type=template&id=47b2e20a&scoped=true&"
import script from "./Deductions.vue?vue&type=script&lang=js&"
export * from "./Deductions.vue?vue&type=script&lang=js&"
import style0 from "./Deductions.vue?vue&type=style&index=0&id=47b2e20a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b2e20a",
  null
  
)

export default component.exports